// Widget de notificaciones de Reportes en Dashboard

import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { apiFetchJson } from '../fetchWrapper';
import { useUser } from '../UserContext';
import { getReportStatusLabel } from './ReportStatus';
import { formatMX } from '../util/DateUtil';
import { usePage } from '../PageContext';

export default function NotificationWidget() {
  const { user, hasRole } = useUser();
  const [reports, setReports] = useState([]);
  const [sites, setSites] = useState([]);
  const [employees, setEmployees] = useState([]);
  const { setPage } = usePage();

  useEffect(() => {
    apiFetchJson("/api/reports").then(setReports);
    apiFetchJson("/api/employees").then(setEmployees);
    apiFetchJson("/api/sites").then(setSites);
  }, []);

  const getSiteName = (siteId) => {
    const site = sites.find(s => s.id === siteId);
    return site ? site.client.companyName + " - " + site.name : "Desconocida";
  }

  const handleClick = () => {
    setPage('reports');
  };

  const getEmployeeName = (employeeId) => {
    const employee = employees.find(e => e.id === employeeId);
    return employee ? `${employee.user.person.firstname} ${employee.user.person.lastnameFirst}` : "";
  }

  const filteredReports = reports.filter(report => {
    if (hasRole(['EMPLOYEE']) && (report.authorId !== user.id && report.assignedToId !== user.id)) {
      return false;
    }
    return true;
  });

  return (
    <Card
      elevation={3}
      sx={{
        height: 325,
        borderRadius: 3,
        backgroundColor: '#eef0f2',
        color: 'black',
        display: 'flex',
        flexDirection: 'column',
      }} onClick={handleClick}
    >
      <CardContent sx={{ flex: 1, overflow: 'auto', p: 1.5 }}>
        <Typography variant="h6" fontSize={25} fontWeight={"bold"}>
          Reportes
        </Typography>

        {filteredReports.map((report) => (
          <Box
            key={report.id}
            sx={{
              p: 1,
              mb: 1,
              borderRadius: 2,
              backgroundColor: '#fff',
            }}
          >
            {/* Top row */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <strong>{getSiteName(report.siteId)}</strong>
              <span>{getReportStatusLabel(report.reportStatus)}</span>
            </Box>

            {/* Subject */}
            <Box
              sx={{
                fontSize: 12,
                fontWeight: 600,
                lineHeight: 1.2,
                mb: 0.3,
              }}
            >
              {report.subject}
            </Box>

            {/* Description (with optional 2-line clamp) */}
            <Box
              sx={{
                fontSize: 11.5,
                fontWeight: 400,
                opacity: 0.75,
                lineHeight: 1.2,

                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {report.description}
            </Box>

            {/* Footer */}
            <Box
              sx={{
                fontSize: 11,
                opacity: 0.6,
                display: 'flex',
                justifyContent: 'space-between',
                mt: 0.5,
              }}
            >
              <span>{getEmployeeName(report.assignedToId)}</span>
              <span>{formatMX(new Date(report.updatedAt))}</span>
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}
